module.exports = __webpack_public_path__ + "static/media/gear.387e3395.svg";